import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { Reveal, SectionLabel } from "@/components/site/primitives";
import { spotlight } from "@/components/site/fx";
import { useI18n } from "@/i18n";

const EASE = [0.22, 1, 0.36, 1];

export const Testimonials = () => {
  const { t, lang } = useI18n();
  return (
    <section
      id="recenzii"
      data-testid="testimonials-section"
      className="relative border-t border-white/10 bg-ink-800"
    >
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
        <div className="max-w-3xl">
          <Reveal>
            <SectionLabel index="[ 04 ]">{t("ts.label")}</SectionLabel>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
              {t("ts.h1")}{" "}
              <span className="text-cyan-neon">{t("ts.hkw")}</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {TESTIMONIALS.map((tm, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-${i}`}
              {...spotlight()}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.1 }}
              whileHover={{ y: -6 }}
              className="spotlight card-edge group flex flex-col justify-between rounded-2xl p-8"
            >
              <Quote
                size={30}
                className="text-cyan-neon/40 transition-colors duration-300 group-hover:text-cyan-neon"
              />
              <blockquote className="mt-6 font-body text-[15px] leading-relaxed text-white/75">
                “{lang === "en" ? tm.quote_en : tm.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3 border-t border-white/10 pt-6">
                <span className="grid h-11 w-11 place-items-center rounded-full border border-cyan-neon/30 bg-cyan-neon/5 font-display text-sm font-bold text-cyan-neon">
                  {tm.name.charAt(0)}
                </span>
                <div>
                  <div className="font-display text-sm font-bold text-white">
                    {tm.name}
                  </div>
                  <div className="font-mono text-[11px] uppercase tracking-wider text-white/40">
                    {lang === "en" ? tm.role_en : tm.role}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
